module.exports = __webpack_public_path__ + "img/design_3.f331e568.png";